import { registerPackageResources } from '../core';
import en from './en.json';
import ko from './ko.json';

const namespace = 'core';

// 타입 확장
declare module 'i18next' {
  interface I18nNamespaces {
    [namespace]: typeof ko;
  }
}

// i18n 리소스
export const coreResources = {
  ko: {
    [namespace]: ko,
  },
  en: {
    [namespace]: en,
  },
};

// 리소스 등록
registerPackageResources({
  namespace: namespace,
  resources: coreResources,
});
